import type { Fallacy } from "./types";
import { createStory } from "./types";

export const misleadingPercentages: Fallacy = {
    id: "misleading-percentages",
    name: "Misleading Percentages",
    emoji: "💯",
    category: "Manipulasi Statistik",
    description: "Menggunakan **persentase tanpa konteks** angka absolut agar terdengar **lebih besar dari kenyataan**.",
    tldr: "\"Naik 200%!\" — dari 1 jadi 3. Gitu doang.",
    detail: "Misleading Percentages terjadi ketika data disajikan dalam bentuk **persentase tanpa angka absolut**, sehingga audiens mendapat kesan keliru tentang skala sebenarnya. \"Naik 200%\" terdengar dahsyat — tapi kalau dari 1 jadi 3, apakah itu signifikan?\n\nSebaliknya, persentase juga bisa mengecilkan angka besar. \"Hanya 0.1% penduduk terdampak\" terdengar kecil, tapi kalau populasinya 270 juta, itu 270.000 orang.\n\nSetiap kali melihat klaim persentase dramatis, selalu tanyakan: \"Berapa angka absolutnya?\" dan \"Dari basis berapa?\" Tanpa dua informasi ini, persentase bisa jadi **alat manipulasi yang sangat efektif**.",
    story: createStory("Misleading Percentages", "💯", {
      hook: {
        title: "\"Naik 200%!\"",
        body: "Kedengeran dahsyat? Bisa jadi cuma dari 1 jadi 3. Gitu doang.",
      },
      convo: {
        claim: "Startup kita berkembang pesat, **growth 500% dalam 3 bulan**! Investor pasti tertarik nih.",
        response: "Dari 10 user jadi 60. **Persentasenya gede, angkanya kecil.**",
      },
      reveal: {
        body: "Persentase **tanpa angka absolut** itu senjata manipulasi. \"Naik 200%\" bisa berarti apa aja — tergantung **dari basis berapa**.",
      },
      insight: {
        title: "Triknya dua arah",
        body: "Persentase bisa bikin kecil jadi gede, tapi juga bikin gede jadi kecil. \"Cuma 0.1% terdampak\" — kedengeran kecil, padahal itu **270.000 orang**.",
      },
      engagement: {
        title: "Paling sering nemu persentase menyesatkan di mana? 💯",
        body: "Pitch startup atau judul berita? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["cherry-picking", "misleading-statistics", "framing-effect"],
  };
